"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _plus = _interopRequireDefault(require("cccisd-icons/plus2"));
var _ConditionsRow = _interopRequireDefault(require("./ConditionsRow"));
var _index = require("../index");
var _cccisdFormik = require("cccisd-formik");
var _style = _interopRequireDefault(require("../style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var Conditions = function Conditions(_ref) {
  var field = _ref.field,
    form = _ref.form;
  var _field$value = field.value,
    conditions = _field$value.conditions,
    nextKey = _field$value.nextKey;
  var conditionsCount = conditions.length;
  var addRow = function addRow() {
    form.setFieldValue('ifThen', _objectSpread(_objectSpread({}, field.value), {}, {
      conditions: [].concat(_toConsumableArray(conditions), [{
        key: nextKey,
        condition: _index.initialCondition
      }]),
      nextKey: nextKey + 1
    }));
  };
  var removeRow = function removeRow(index) {
    if (conditionsCount <= 1) return;
    var updated = _toConsumableArray(conditions);
    updated.splice(index, 1);
    form.setFieldValue('ifThen', _objectSpread(_objectSpread({}, field.value), {}, {
      conditions: updated
    }));
  };
  var moveUp = function moveUp(index) {
    if (conditionsCount <= 1 || index === 0) return;
    var updated = [];
    conditions.forEach(function (c, i) {
      if (i === index - 1) updated.push(conditions[index]);
      if (i !== index) updated.push(c);
    });
    form.setFieldValue('ifThen', _objectSpread(_objectSpread({}, field.value), {}, {
      conditions: updated
    }));
  };
  var moveDown = function moveDown(index) {
    if (conditionsCount <= 1 || conditionsCount === index + 1) return;
    var updated = [];
    conditions.forEach(function (c, i) {
      if (i !== index) updated.push(c);
      if (i === index + 1) updated.push(conditions[index]);
    });
    form.setFieldValue('ifThen', _objectSpread(_objectSpread({}, field.value), {}, {
      conditions: updated
    }));
  };
  var hr = /*#__PURE__*/_react["default"].createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-xs-12"
  }, /*#__PURE__*/_react["default"].createElement("hr", null)));
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-xs-6 text-right"
  }, /*#__PURE__*/_react["default"].createElement("strong", null, "If rule is true"), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("span", {
    className: _style["default"].rulesOrderText
  }, "Rules are evaluated in order they appear")), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-xs-6"
  }, /*#__PURE__*/_react["default"].createElement("strong", null, "Then set formula value to"))), hr, conditions.map(function (condition, index) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
      key: condition.key
    }, /*#__PURE__*/_react["default"].createElement(_ConditionsRow["default"], {
      index: index,
      conditionsCount: conditionsCount,
      removeRow: removeRow,
      moveUp: moveUp,
      moveDown: moveDown
    }), hr);
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-xs-12 text-right"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: "btn btn-default",
    onClick: addRow,
    type: "button"
  }, /*#__PURE__*/_react["default"].createElement(_plus["default"], null), " Add If Then Rule"))), hr, /*#__PURE__*/_react["default"].createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-xs-6 text-right ".concat(_style["default"].otherwise)
  }, "Otherwise"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-xs-6"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].value
  }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "ifThen.otherwise",
    component: _cccisdFormik.CccisdInput
  })))), hr);
};
Conditions.propTypes = {
  field: _propTypes["default"].object,
  form: _propTypes["default"].object
};
var _default = Conditions;
exports["default"] = _default;